export default __webpack_public_path__ + "img/waitingFor2.e44dfe99.gif";